export const SIR_DET_COMBOS_IDS = [
  'estados_solicitud_sir',
  'estado_finca',
  'diametro_tallo',
  // 'presion_gas',
  'tipo_trabajos_realizar',
  'sir_sstt',
]
